import React from "react";

type ButtonProps = {
  customClassName?: string;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  children?: string | React.ReactNode;
};

const Button: React.FC<ButtonProps> = ({
  customClassName,
  disabled,
  type,
  children,
}) => {
  return (
    <button
      className={`disabled:cursor-not-allowed cursor-pointer flex h-12 md:h-11 px-6 py-4 justify-center items-center gap-[6px] 
        self-stretch text-base font-semibold not-italic leading-4 text-forest-900 disabled:text-forest-700 rounded-full disabled:bg-sun-300 bg-sun-600 ${customClassName}`}
      disabled={disabled}
      type={type}
    >
      {children}
    </button>
  );
};

export default Button;
